import React from 'react';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ onConfirm }) => {
  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 className="session-expired-title">Session Expired</h2>
        <p className="session-expired-message">
          Your session has expired. Please sign in again to continue.
        </p>
        <button 
          className="session-expired-button"
          onClick={onConfirm}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
